import { useReactiveVar } from '@bestseller/retail-planning.utils.reactive-vars';
import { useMemo } from 'react';
import { Module } from 'src/domain';
import { selectedPartnerVar } from 'src/infrastructure/local_state';
import { useCurrentModule } from './useCurrentModule';

const modulesToExclude = new Set<Module>([Module.StyleFamilyNameEditor]);

export function useHasPartnerSelection(): boolean {
    const [selectedPartner, _] = useReactiveVar(selectedPartnerVar);
    const currentModule = useCurrentModule();

    return useMemo(
        () => !!selectedPartner && !!currentModule && !modulesToExclude.has(currentModule),
        [currentModule, selectedPartner]
    );
}
